import axiosInstance from '../../../config/axiosInstance';
const LeadService = {
    async GetLeadCommunication(redirectCallback, LeadID, Start, PageSize, searchQuery, sortColumn, sortDirection, EmailingName = "", SearchColumns, AssignTo) {
        try {

            Start = Start ?? 1;
            PageSize = PageSize ?? 1000;
            searchQuery = searchQuery ?? "";
            sortColumn = sortColumn ?? "ID";
            sortDirection = sortDirection ?? "DESC";
            SearchColumns = SearchColumns ?? "ALL";

            const ClientID = localStorage.getItem('CompanyID');


            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Lead/GetLeadCommunication?LeadID=${LeadID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetLeadCommunicationCount(redirectCallback, LeadID, searchQuery, EmailingName = "", SearchColumns, AssignTo) {
        try {
            const ClientID = localStorage.getItem('CompanyID');


            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Lead/GetLeadCommunicationCount?LeadID=${LeadID}&searchQuery=${searchQuery}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
     async GetAllOppurtunityCommunication(redirectCallback, OppurtunityID, Start, PageSize, searchQuery, sortColumn, sortDirection, EmailingName = "", SearchColumns, AssignTo) {
        try {
            
             Start = Start ?? 1;
            PageSize = PageSize ?? 1000;
            searchQuery = searchQuery ?? "";
            sortColumn = sortColumn ?? "ID";
            sortDirection = sortDirection ?? "DESC";
            SearchColumns = SearchColumns ?? "ALL";

            const ClientID = localStorage.getItem('CompanyID');


            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Lead/GetAllOppurtunityCommunication?OppurtunityID=${OppurtunityID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;          
            
           
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetOppurtunityCommunicationCount(redirectCallback, OppurtunityID, searchQuery, EmailingName = "", SearchColumns, AssignTo) {
        try {
            const ClientID = localStorage.getItem('CompanyID');


            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Lead/GetOppurtunityCommunicationCount?OppurtunityID=${OppurtunityID}&searchQuery=${searchQuery}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetOppurtunityCommunication(redirectCallback, OppurtunityID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Lead/GetOppurtunityCommunication?OppurtunityID=${OppurtunityID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetCommunicationID(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Lead/GetCommunicationID?ID=${ID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteCommunication(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Lead/DeleteCommunication?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async LeadSendEmail2(formData, pdfAttachment) {
        try {
            debugger; // 🛠 Step 1: Check data before processing

            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");

            // ✅ Convert `formData` object into `FormData`
            const formDataToSend = new FormData();

            // ✅ Append text fields manually
            Object.entries(formData).forEach(([key, value]) => {
                console.log(`Appending: ${key} => ${value}`); // 🛠 Debugging each field
                formDataToSend.append(key, value);
            });

            // ✅ Append additional fields
            formDataToSend.append("ClientID", CompanyID);
            formDataToSend.append("UserID", UserID);

            // ✅ Ensure `pdfAttachment` is a valid File/Blob before appending
            if (pdfAttachment instanceof File) {
                formDataToSend.append("attachment", pdfAttachment);
            } else if (pdfAttachment instanceof Blob) {
                const pdfFile = new File([pdfAttachment], "JobCostReport.pdf", { type: "application/pdf" });
                formDataToSend.append("attachment", pdfFile);
            } else {
                console.warn("⚠️ pdfAttachment is not a valid File or Blob:", pdfAttachment);
            }

            // 🛠 Debugging: Print `FormData` values before sending
            console.log("🚀 Final FormData Before Sending:");
            formDataToSend.forEach((value, key) => {
                console.log(key, value);
            });

            const response = await axiosInstance.post(`/Lead/LeadSendEmail`, formDataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data", // Axios sets automatically
                },
            });

            return response.data.message;
        } catch (error) {
            console.error("❌ Error sending email:", error);
            throw error;
        }
    },


    async LeadSendEmailAttachment(formData, pdfAttachment) {
        try {
            console.log("📌 Sending Email Data:", formData);

            const CompanyID = localStorage.getItem("CompanyID") || "UnknownCompany";
            const UserID = localStorage.getItem("UserID") || "UnknownUser";

            const emailData = {
                ClientID: CompanyID,
                UserID: UserID,
                vc_From: formData.vc_From || "",
                vc_To: formData.vc_To || "",
                vc_CC: formData.vc_CC || "",
                vc_Subject: formData.vc_Subject || "",
                vc_Description: formData.vc_Description || "",
            };

            // ✅ Create FormData Object
            const MailSender = new FormData();
            MailSender.append("data", JSON.stringify(emailData)); // Send JSON as a field

            // ✅ Attach File if Available
            if (pdfAttachment) {
                MailSender.append("attachment", pdfAttachment, pdfAttachment.name);
            }

            const response = await axiosInstance.post(`/Lead/LeadSendEmailAttachment`, MailSender, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            console.log("✅ Email Sent Successfully:", response.data);
            return response.data;

        } catch (error) {
            console.error("❌ Error Sending Email:", error.response?.data || error.message);
            throw error;
        }
    },

    async LeadSendEmail(data) {
        try {

            const CompanyID = localStorage.getItem("CompanyID");
            data.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            data.UserID = UserID;
            const response = await axiosInstance.post(`/Lead/LeadSendEmail`, data);
            return response.data.message;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async LeadSendMultipleEmail(data) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            data.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            data.UserID = UserID;
            const response = await axiosInstance.post(`/Lead/LeadSendMultipleEmail`, data);
            return response.data.message;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
};

export default LeadService;